import { gql, TypedDocumentNode } from "@apollo/client";

import {
  GetCurrentUserQuery,
  GetCurrentUserQueryVariables,
} from "./CurrentUser.generated";

const CURRENT_USER_QUERY: TypedDocumentNode<
  GetCurrentUserQuery,
  GetCurrentUserQueryVariables
> = gql`
  query GetCurrentUser {
    user {
      email
      firstName
      lastName
      uuid
      isScribe
      isConfirmed
      createdAt
      scribephoneConsentOptIn
      requiresRecordingConsent
      recordingConsentHeader
      recordingConsentText
      recordingConsentVersion
      organization {
        uuid
      }
      role {
        id
      }
      isOnboardingComplete
      pimsProvider
      userPermissions {
        permissionName
        isEnabled
      }
      featureActivations {
        featureName
        isActivated
      }
      referral {
        referralCode
        creditsBalanceCents
        totalCreditsEarnedCents
        totalCreditsRedeemedCents
        canRedeem
        minRedemptionAmountCents
        numReferredSignups
        numPaidReferrals
        hasReferrer
      }
      account {
        uuid
        isSubscribed
        accountType
        freeTrialExpiresAt
        preferences
      }
      verifiedPhoneNumbers {
        verifiedPhoneNumberUuid
        phoneNumber
        twilioVerificationStatus
        isDeleted
      }
      teams {
        numUsers
        uuid
        name
        createdAt
        location
        users {
          uuid
          firstName
          lastName
        }
      }
      clientSummaryPreferences {
        frontmatter
        backmatter
        visitSummary
        abnormalPhysicalFindings
        vitals
        allFindings
        pointFormSummary
        oneLineSummary
        ownerInstructions
        medications
        vaccinations
        diagnostics
        diet
        followUpAppointments
        homeCare
      }
    }
  }
`;

export default CURRENT_USER_QUERY;
